import { string } from 'prop-types'

export const strWithCommas = (string = '') => {
  return string
    .toString()
    .replace(/\D/g, '')
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const numberRemoveCommas = (string = '') => {
  return string.toString().replace(/\D/g, '')
}

export const numberWithCommas = (string = '') => {
  const notNaN = !isNaN(string)
  if (notNaN) {
    return Number(string).toLocaleString()
  }
}

export const numberDecimalRemoveCommas = (string = '') => {
  return string.toString().replace(/,/g, '')
}
